<template>
  <div id="app">
    <portal-header />
    <router-view />
    <portal-footer />
    <back-to-top />
    <contact-float />
  </div>
</template>

<script>
import PortalHeader from '@/components/PortalHeader.vue'
import PortalFooter from '@/components/PortalFooter.vue'
import ContactFloat from '@/components/ContactFloat.vue'
import BackToTop from '@/components/BackToTop.vue'

export default {
  name: 'App',
  components: { PortalHeader, PortalFooter, ContactFloat, BackToTop },
  mounted() {
    this.$store.dispatch('loadSiteConfig')
  },
  watch: {
    '$store.state.lang'() {
      this.$store.dispatch('loadSiteConfig')
    },
    '$store.state.siteConfig'() {
      this.updateMeta()
    },
    '$route'() {
      this.updateMeta()
    }
  },
  methods: {
    setMeta(attr, key, content) {
      let el = document.querySelector(`meta[${attr}="${key}"]`)
      if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, key)
        document.head.appendChild(el)
      }
      el.setAttribute('content', content)
    },
    updateMeta() {
      const config = this.$store.state.siteConfig
      if (!config || !config.siteName) return
      const navKey = this.$route.meta && this.$route.meta.navKey
      let title
      if (navKey && navKey !== 'nav.home') {
        title = `${this.$t(navKey)} - ${config.siteName}`
      } else {
        title = config.siteSlogan
          ? `${config.siteName} - ${config.siteSlogan}`
          : config.siteName
      }
      document.title = title
      this.setMeta('property', 'og:title', title)
      if (config.siteSlogan) {
        this.setMeta('name', 'description', config.siteSlogan)
        this.setMeta('property', 'og:description', config.siteSlogan)
      }
      if (config.siteLogo) {
        this.setMeta('property', 'og:image', config.siteLogo)
      }
    }
  }
}
</script>
